const timer = setInterval(nextImage, 4000);
const images = document.querySelectorAll('.js-crossfade-images > *');
var curImage = 0;

function nextImage() {
	// remove data-active from current image
	images[curImage].removeAttribute('data-active');

	// compute next image
	curImage++;
	if (curImage > images.length - 1) {
		curImage = 0;
	}

	// add data-active="true" class to next image
	images[curImage].setAttribute('data-active', 'true');
}
